export default "__VITE_ASSET__RHdsYhVJ__"